/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketSimilarTickets } from '../../models/support-ticket-similar-tickets';

export interface GetSimiliarTickets$Params {
      body?: {
'id'?: number;
'searchString'?: string;
}
}

export function GetSimiliarTickets(http: HttpClient, rootUrl: string, params?: GetSimiliarTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SupportTicketSimilarTickets>>> {
  const rb = new RequestBuilder(rootUrl, GetSimiliarTickets.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SupportTicketSimilarTickets>>;
    })
  );
}

GetSimiliarTickets.PATH = '/api/Tickets/GetSimiliarTickets';
